export const sequence_detail_targets_en = {
  sequence_targets_column_account_at: "at",
  sequence_detail_targets: "targets",
  sequence_detail_targets_count: "0 targets | 1 target | {count} targets",
  sequence_targets_column_account: "Account",
  sequence_targets_column_step_name: "Sequence step",
  sequence_targets_column_status: "Sequence status",
  sequence_targets_column_save_contact_to: "Save contact to",
  sequence_targets_column_contact: "Contact",
  remove_sequences_from_target_successfully: "Removed succssfully",
  remove_sequences_from_target_failed: "Failed to remove",
  add_targets_to_sequence_successfully: "Added successfully",
  add_targets_to_sequence_failed: "Failed to add",
  sequence_targets_sequence_unsave_count:
    "0 targets | 1 target | {count} targets",
  sequence_create_sequence: "create a sequence",
  sequence_action_sequence_empty:
    "Create a sequence to start automating your outreach and add items here when you're ready.",
  sequence_targets_import_csv_loading_title: "Analyzing your data…",
  sequence_targets_import_csv_loading_desc:
    "Finding columns like email, name, and company...",
  drag_and_drop: "Drag & Drop or",
  sample_csv: "contact_sequence_samplefile.csv",
  sequence_targets_import_upload_csv: "Upload CSV",
  sequence_targets_import_map_attributes: "Field Mapping",
  is_override_existing_sequence: "Override existing sequence",
  is_override_existing_sequence_desc:
    "If a sequence with the same identifier already exists, skip it and don’t update.",
  is_override_all_sequences: "Override all sequences",
  is_override_all_sequences_desc:
    "If another sequence has the same identifier, update it with this new one.",
  sequence_targets_import_csv_map_crm_column: "Fields",
  sequence_targets_import_csv_map_file_column: "File columns",
  sequence_targets_import_csv_upload_success: "Upload Complete",
  sequence_targets_import_csv_upload_summary: "Summary of Results",
  sequence_targets_import_csv_upload_summary_upload_success:
    "Uploaded successfully:",
  sequence_targets_import_csv_upload_summary_targets:
    "0 targets | 1 targets | {count} targets",
  sequence_targets_import_csv_upload_summary_upload_skip:
    "Skipped (already assigned or duplicate):",
  sequence_targets_create_manual_drawer_title: "Create Targets",
  locations_company_locations: "Account HQ",
  locations_people_locations: "Contact HQ",
  sequence_targets_add_import_from_csv_button_name: "Import from CSV",
  sequence_targets_add_create_manual_button_name: "Create manually",
  sequence_detail_target_add_targets: "Add contacts",
  sequence_targets_filter_steps_version: "Version",
  sequence_targets_filter_steps_action: "Action",

  sequence_targets_filter_sequence_status: "Sequence Status",
  sequence_targets_filter_steps: "Steps",
  sequence_targets_filter_name: "Name",
  sequence_targets_filter_job_title: "Job Title",
  sequence_targets_filter_management_level: "Management Level",
  sequence_targets_filter_department: "Department",
  sequence_targets_filter_job_function: "Job Functions",
  sequence_targets_filter_company: "Company",
  sequence_targets_filter_location: "Location",
  sequence_targets_filter_employees: "Employees",

  steps_sequence_steps: "Version",
  steps_sequence_step_actions: "Action",

  sequence_target_bar_finish_tooltip: "Mark Sequence as finished",
  sequence_target_bar_pause_tooltip: "Pause Sequence",
  sequence_target_bar_play_tooltip: "Resume Sequence",
  sequence_target_bar_remove_tooltip: "Remove from Sequence",
  sequence_target_bar_export_tooltip: "Export",

  not_a_portal_record: "Not a portal record (yet)",

  sequence_targets_identifier_explaination:
    "Set an identifier to help detect and manage duplicates accurately",

  sequence_targets_import_replace: "Replace duplicates",
  sequence_targets_import_replace_desc:
    "If a contact already exists, overwrite it with the CSV version.",
  sequence_targets_import_merge: "Skip duplicates",
  sequence_targets_import_merge_desc:
    "Keep existing contacts, only add new ones.",
  sequence_targets_import_skip: "Merge duplicates",
  sequence_targets_import_skip_desc:
    "If a contact exists, combine both records. Add new ones too.",
  sequence_targets_import_update: "Update only",
  sequence_targets_import_update_desc:
    "Only update existing contacts. Do not add new ones.",
  sequence_targets_import_csv_batch_create_fields_title:
    "Assign field types for new attributes",
  create_fields: "Create fields",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_label:
    "Field name",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_placeholder:
    "Please enter field name",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_label:
    "Field type",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_placeholder:
    "Please select field type",
  set_for_all: "Set for all",

  sequence_targets_import_csv_fields_map_settings_duplicate_handling_label:
    "Duplicate handling",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_title:
    "Overwrite changes",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_desc:
    "If the target already exists in any sequence, it is overwritten.",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_title:
    "Replace duplicates",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_desc:
    "If the target already exists in the current sequence, it is overwritten.",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_title:
    "Merge duplicates",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_desc:
    "If the target already exists, combine both records.",
  text_separator: "Text Group Separator",
  text_separator_placeholder: "Please enter the text group separator",
  auto_create_column: "Auto Create Column",
  new_column_type: "New Column Type",
  new_column_type_placeholder: "Assign field types",

  sequence_targets_import_csv_map_fields_submit_button: "Import contacts",
};

export const sequence_detail_targets_zhHant = {
  sequence_targets_column_account_at: "於",
  sequence_detail_targets: "目標",
  sequence_detail_targets_count: "0 個目標 | 1 個目標 | {count} 個目標",
  sequence_targets_column_account: "帳戶",
  sequence_targets_column_step_name: "流程步驟",
  sequence_targets_column_status: "流程狀態",
  sequence_targets_column_save_contact_to: "儲存聯絡人至",
  sequence_targets_column_contact: "聯絡人",
  remove_sequences_from_target_successfully: "移除成功",
  remove_sequences_from_target_failed: "移除失敗",
  add_targets_to_sequence_successfully: "新增成功",
  add_targets_to_sequence_failed: "新增失敗",
  sequence_targets_sequence_unsave_count:
    "0 個目標 | 1 個目標 | {count} 個目標",
  sequence_create_sequence: "建立流程",
  sequence_action_sequence_empty:
    "建立一個流程以開始自動化聯繫，並在準備好後新增項目至此處。",
  sequence_targets_import_csv_loading_title: "正在分析資料⋯",
  sequence_targets_import_csv_loading_desc:
    "正在尋找欄位，例如電子郵件、姓名與公司⋯",
  drag_and_drop: "拖放或",
  sample_csv: "contact_sequence_samplefile.csv",
  sequence_targets_import_upload_csv: "上傳 CSV",
  sequence_targets_import_map_attributes: "字段映射",
  is_override_existing_sequence: "覆蓋現有流程",
  is_override_existing_sequence_desc:
    "若已有相同識別碼的流程，則略過並不更新。",
  is_override_all_sequences: "覆蓋所有流程",
  is_override_all_sequences_desc:
    "若有其他流程具有相同識別碼，則以此新流程更新。",
  sequence_targets_import_csv_map_crm_column: "字段",
  sequence_targets_import_csv_map_file_column: "檔案欄位",
  sequence_targets_import_csv_upload_success: "上傳完成",
  sequence_targets_import_csv_upload_summary: "結果摘要",
  sequence_targets_import_csv_upload_summary_upload_success: "成功上傳：",
  sequence_targets_import_csv_upload_summary_targets:
    "0 個目標 | 1 個目標 | {count} 個目標",
  sequence_targets_import_csv_upload_summary_upload_skip:
    "已跳過（已分配或重複）：",
  sequence_targets_create_manual_drawer_title: "建立目標",
  locations_company_locations: "帳戶總部",
  locations_people_locations: "聯絡人總部",
  sequence_targets_add_import_from_csv_button_name: "從 CSV 匯入",
  sequence_targets_add_create_manual_button_name: "手動建立",
  sequence_detail_target_add_targets: "新增聯絡人",
  sequence_targets_filter_steps_version: "版本",
  sequence_targets_filter_steps_action: "操作",

  sequence_targets_filter_sequence_status: "流程狀態",
  sequence_targets_filter_steps: "步驟",
  sequence_targets_filter_name: "姓名",
  sequence_targets_filter_job_title: "職稱",
  sequence_targets_filter_management_level: "管理層級",
  sequence_targets_filter_department: "部門",
  sequence_targets_filter_job_function: "職能",
  sequence_targets_filter_company: "公司",
  sequence_targets_filter_location: "位置",
  sequence_targets_filter_employees: "員工人數",

  steps_sequence_steps: "版本",
  steps_sequence_step_actions: "節點",

  sequence_target_bar_finish_tooltip: "標記工作流程為已完成",
  sequence_target_bar_pause_tooltip: "暫停工作流程",
  sequence_target_bar_play_tooltip: "恢復工作流程",
  sequence_target_bar_remove_tooltip: "從工作流程中移除",
  sequence_target_bar_export_tooltip: "匯出",

  not_a_portal_record: "尚未成為portal記錄",

  sequence_targets_identifier_explaination:
    "設置識別符，以幫助準確偵測並管理重複項",

  sequence_targets_import_replace: "替換重複項",
  sequence_targets_import_replace_desc: "如果聯絡人已存在，使用CSV版本覆蓋。",

  sequence_targets_import_merge: "跳過重複項",
  sequence_targets_import_merge_desc: "保留現有聯絡人，僅新增新聯絡人。",

  sequence_targets_import_skip: "合併重複項",
  sequence_targets_import_skip_desc:
    "如果聯絡人存在，合併兩條記錄。同時新增新聯絡人。",
  sequence_targets_import_csv_batch_create_fields_title: "為新屬性分配欄位類型",
  create_fields: "建立欄位",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_label:
    "欄位名稱",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_placeholder:
    "請輸入欄位名稱",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_label:
    "欄位類型",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_placeholder:
    "請選擇欄位類型",
  set_for_all: "全部設定",
  sequence_targets_import_update: "僅更新",
  sequence_targets_import_update_desc: "僅更新現有聯絡人。不新增新聯絡人。",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_label:
    "重複項處理",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_title:
    "覆蓋變更",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_desc:
    "如果目標已存在於任何序列中，將被覆蓋。",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_title:
    "替換重複項",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_desc:
    "如果目標已存在於目前序列中，將被覆蓋。",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_title:
    "合併重複項",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_desc:
    "如果目標已存在，合併兩條記錄。",
  text_separator: "文字組分隔符",
  text_separator_placeholder: "請輸入文字組分隔符",
  auto_create_column: "自動建立欄位",
  new_column_type: "新欄位類型",
  new_column_type_placeholder: "分配欄位類型",
  sequence_targets_import_csv_map_fields_submit_button: "匯入聯絡人",
};

export const sequence_detail_targets_zhHans = {
  sequence_targets_column_account_at: "于",
  sequence_detail_targets: "目标",
  sequence_detail_targets_count: "0 个目标 | 1 个目标 | {count} 个目标",
  sequence_targets_column_account: "账户",
  sequence_targets_column_step_name: "流程步骤",
  sequence_targets_column_status: "流程状态",
  sequence_targets_column_save_contact_to: "保存联系人到",
  sequence_targets_column_contact: "联系人",
  remove_sequences_from_target_successfully: "移除成功",
  remove_sequences_from_target_failed: "移除失败",
  add_targets_to_sequence_successfully: "添加成功",
  add_targets_to_sequence_failed: "添加失败",
  sequence_targets_sequence_unsave_count:
    "0 个目标 | 1 个目标 | {count} 个目标",
  sequence_create_sequence: "创建流程",
  sequence_action_sequence_empty:
    "创建一个流程以开始自动化触达，准备好后可将项目添加到此处。",
  sequence_targets_import_csv_loading_title: "正在分析数据…",
  sequence_targets_import_csv_loading_desc: "正在查找列，如邮箱、姓名和公司...",
  drag_and_drop: "拖放文件或",
  sample_csv: "contact_sequence_samplefile.csv",
  sequence_targets_import_upload_csv: "上传 CSV",
  sequence_targets_import_map_attributes: "字段映射",
  is_override_existing_sequence: "覆盖已有流程",
  is_override_existing_sequence_desc:
    "如果已有相同标识的流程，则跳过并不更新。",
  is_override_all_sequences: "覆盖所有流程",
  is_override_all_sequences_desc:
    "如果存在其他具有相同标识的流程，则用新流程更新。",
  sequence_targets_import_csv_map_crm_column: "字段",
  sequence_targets_import_csv_map_file_column: "文件列",
  sequence_targets_import_csv_upload_success: "上传完成",
  sequence_targets_import_csv_upload_summary: "结果汇总",
  sequence_targets_import_csv_upload_summary_upload_success: "成功上传：",
  sequence_targets_import_csv_upload_summary_targets:
    "0 个目标 | 1 个目标 | {count} 个目标",
  sequence_targets_import_csv_upload_summary_upload_skip:
    "跳过（已分配或重复）：",
  sequence_targets_create_manual_drawer_title: "创建目标",
  locations_company_locations: "账户总部",
  locations_people_locations: "联系人总部",
  sequence_targets_add_import_from_csv_button_name: "从 CSV 导入",
  sequence_targets_add_create_manual_button_name: "手动创建",
  sequence_detail_target_add_targets: "添加联系人",
  sequence_targets_filter_steps_version: "版本",
  sequence_targets_filter_steps_action: "操作",

  sequence_targets_filter_sequence_status: "流程状态",
  sequence_targets_filter_steps: "步骤",
  sequence_targets_filter_name: "姓名",
  sequence_targets_filter_job_title: "职位",
  sequence_targets_filter_management_level: "管理层级",
  sequence_targets_filter_department: "部门",
  sequence_targets_filter_job_function: "职能",
  sequence_targets_filter_company: "公司",
  sequence_targets_filter_location: "位置",
  sequence_targets_filter_employees: "员工人数",

  steps_sequence_steps: "版本",
  steps_sequence_step_actions: "节点",

  sequence_target_bar_finish_tooltip: "标记工作流程为已完成",
  sequence_target_bar_pause_tooltip: "暂停工作流程",
  sequence_target_bar_play_tooltip: "恢复工作流程",
  sequence_target_bar_remove_tooltip: "从工作流程中移除",
  sequence_target_bar_export_tooltip: "导出",

  not_a_portal_record: "尚不是门户记录",

  sequence_targets_identifier_explaination:
    "设置标识符，以帮助准确检测和管理重复项",

  sequence_targets_import_replace: "替换重复项",
  sequence_targets_import_replace_desc: "如果联系人已存在，使用CSV版本覆盖。",

  sequence_targets_import_merge: "跳过重复项",
  sequence_targets_import_merge_desc: "保留现有联系人，仅添加新联系人。",

  sequence_targets_import_skip: "合并重复项",
  sequence_targets_import_skip_desc:
    "如果联系人存在，合并两条记录。同时添加新联系人。",

  sequence_targets_import_csv_batch_create_fields_title: "为新属性分配字段类型",
  create_fields: "创建字段",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_label:
    "字段名称",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_placeholder:
    "请输入字段名称",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_label:
    "字段类型",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_placeholder:
    "请选择字段类型",
  set_for_all: "全部设置",
  sequence_targets_import_update: "仅更新",
  sequence_targets_import_update_desc: "仅更新现有联系人。不添加新联系人。",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_label:
    "重复项处理",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_title:
    "覆盖更改",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_desc:
    "如果目标已存在于任何序列中，将被覆盖。",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_title:
    "替换重复项",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_desc:
    "如果目标已存在于当前序列中，将被覆盖。",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_title:
    "合并重复项",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_desc:
    "如果目标已存在，合并两条记录。",
  text_separator: "文本组分隔符",
  text_separator_placeholder: "请输入文本组分隔符",
  auto_create_column: "自动创建列",
  new_column_type: "新列类型",
  new_column_type_placeholder: "分配字段类型",
  sequence_targets_import_csv_map_fields_submit_button: "导入联系人",
};

export const sequence_detail_targets_japanese = {
  sequence_targets_column_account_at: "で",
  sequence_detail_targets: "ターゲット",
  sequence_detail_targets_count:
    "0 ターゲット | 1 ターゲット | {count} ターゲット",
  sequence_targets_column_account: "アカウント",
  sequence_targets_column_step_name: "プロセスステップ",
  sequence_targets_column_status: "プロセス状態",
  sequence_targets_column_save_contact_to: "連絡先を保存",
  sequence_targets_column_contact: "連絡先",
  remove_sequences_from_target_successfully: "削除成功",
  remove_sequences_from_target_failed: "削除失敗",
  add_targets_to_sequence_successfully: "追加成功",
  add_targets_to_sequence_failed: "追加失敗",
  sequence_targets_sequence_unsave_count:
    "0 ターゲット | 1 ターゲット | {count} ターゲット",
  sequence_create_sequence: "プロセス作成",
  sequence_action_sequence_empty:
    "自動化連絡を開始するためにプロセスを作成し、準備ができたら項目をここに追加します。",
  sequence_targets_import_csv_loading_title: "データ分析中⋯",
  sequence_targets_import_csv_loading_desc:
    "メール、名前、会社などのフィールドを検索中⋯",
  drag_and_drop: "ドラッグ＆ドロップまたは",
  sample_csv: "contact_sequence_samplefile.csv",
  sequence_targets_import_upload_csv: "CSVをアップロード",
  sequence_targets_import_map_attributes: "フィールドマッピング",
  is_override_existing_sequence: "既存プロセスを上書き",
  is_override_existing_sequence_desc:
    "同じ識別子のプロセスが既にある場合、スキップして更新しません。",
  is_override_all_sequences: "全てのプロセスを上書き",
  is_override_all_sequences_desc:
    "同じ識別子の他のプロセスがある場合、この新しいプロセスで更新します。",
  sequence_targets_import_csv_map_crm_column: "フィールド",
  sequence_targets_import_csv_map_file_column: "ファイルフィールド",
  sequence_targets_import_csv_upload_success: "アップロード完了",
  sequence_targets_import_csv_upload_summary: "結果概要",
  sequence_targets_import_csv_upload_summary_upload_success:
    "成功したアップロード：",
  sequence_targets_import_csv_upload_summary_targets:
    "0 ターゲット | 1 ターゲット | {count} ターゲット",
  sequence_targets_import_csv_upload_summary_upload_skip:
    "スキップ（割り当て済みまたは重複）：",
  sequence_targets_create_manual_drawer_title: "ターゲット作成",
  locations_company_locations: "アカウント本社",
  locations_people_locations: "連絡先本社",
  sequence_targets_add_import_from_csv_button_name: "CSVからインポート",
  sequence_targets_add_create_manual_button_name: "手動作成",
  sequence_detail_target_add_targets: "連絡先を追加",
  sequence_targets_filter_steps_version: "バージョン",
  sequence_targets_filter_steps_action: "操作",

  sequence_targets_filter_sequence_status: "プロセス状態",
  sequence_targets_filter_steps: "ステップ",
  sequence_targets_filter_name: "名前",
  sequence_targets_filter_job_title: "職位",
  sequence_targets_filter_management_level: "管理レベル",
  sequence_targets_filter_department: "部門",
  sequence_targets_filter_job_function: "職能",
  sequence_targets_filter_company: "会社",
  sequence_targets_filter_location: "場所",
  sequence_targets_filter_employees: "従業員数",

  steps_sequence_steps: "バージョン",
  steps_sequence_step_actions: "ノード",

  sequence_target_bar_finish_tooltip: "ワークフローを完了としてマーク",
  sequence_target_bar_pause_tooltip: "ワークフローを一時停止",
  sequence_target_bar_play_tooltip: "ワークフローを再開",
  sequence_target_bar_remove_tooltip: "ワークフローから削除",
  sequence_target_bar_export_tooltip: "エクスポート",

  not_a_portal_record: "まだポータル記録ではありません",

  sequence_targets_identifier_explaination:
    "重複を正確に検出して管理するために識別子を設定します",

  sequence_targets_import_replace: "重複を置換",
  sequence_targets_import_replace_desc:
    "連絡先が既に存在する場合、CSVバージョンで上書きします。",

  sequence_targets_import_merge: "重複をスキップ",
  sequence_targets_import_merge_desc:
    "既存の連絡先を保持し、新しいもののみ追加します。",

  sequence_targets_import_skip: "重複をマージ",
  sequence_targets_import_skip_desc:
    "連絡先が存在する場合、両方のレコードを結合します。新しいものも追加します。",

  sequence_targets_import_csv_batch_create_fields_title:
    "新しい属性にフィールドタイプを割り当て",
  create_fields: "フィールドを作成",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_label:
    "フィールド名",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_placeholder:
    "フィールド名を入力してください",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_label:
    "フィールドタイプ",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_placeholder:
    "フィールドタイプを選択してください",
  set_for_all: "すべてに設定",
  sequence_targets_import_update: "更新のみ",
  sequence_targets_import_update_desc:
    "既存の連絡先のみ更新します。新しいものは追加しません。",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_label:
    "重複処理",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_title:
    "変更を上書き",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_desc:
    "ターゲットが既にいずれかのシーケンスに存在する場合、上書きされます。",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_title:
    "重複を置換",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_desc:
    "ターゲットが現在のシーケンスに既に存在する場合、上書きされます。",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_title:
    "重複をマージ",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_desc:
    "ターゲットが既に存在する場合、両方のレコードを結合します。",
  text_separator: "テキストグループ区切り文字",
  text_separator_placeholder: "テキストグループ区切り文字を入力してください",
  auto_create_column: "列の自動作成",
  new_column_type: "新しい列タイプ",
  new_column_type_placeholder: "フィールドタイプを割り当て",
  sequence_targets_import_csv_map_fields_submit_button: "連絡先をインポート",
};

export const sequence_detail_targets_korean = {
  sequence_targets_column_account_at: "에서",
  sequence_detail_targets: "타겟",
  sequence_detail_targets_count: "0개 타겟 | 1개 타겟 | {count}개 타겟",
  sequence_targets_column_account: "계정",
  sequence_targets_column_step_name: "프로세스 단계",
  sequence_targets_column_status: "프로세스 상태",
  sequence_targets_column_save_contact_to: "연락처 저장 위치",
  sequence_targets_column_contact: "연락처",
  remove_sequences_from_target_successfully: "제거 성공",
  remove_sequences_from_target_failed: "제거 실패",
  add_targets_to_sequence_successfully: "추가 성공",
  add_targets_to_sequence_failed: "추가 실패",
  sequence_targets_sequence_unsave_count:
    "0개 타겟 | 1개 타겟 | {count}개 타겟",
  sequence_create_sequence: "프로세스 생성",
  sequence_action_sequence_empty:
    "자동화 연락을 시작하려면 프로세스를 생성하고 준비가 되면 항목을 여기에 추가하세요.",
  sequence_targets_import_csv_loading_title: "데이터 분석 중⋯",
  sequence_targets_import_csv_loading_desc:
    "이메일, 이름, 회사 등의 필드를 찾는 중⋯",
  drag_and_drop: "드래그 앤 드롭 또는",
  sample_csv: "contact_sequence_samplefile.csv",
  sequence_targets_import_upload_csv: "CSV 업로드",
  sequence_targets_import_map_attributes: "필드 매핑",
  is_override_existing_sequence: "기존 프로세스 덮어쓰기",
  is_override_existing_sequence_desc:
    "동일한 식별자의 프로세스가 이미 있는 경우 건너뛰고 업데이트하지 않습니다.",
  is_override_all_sequences: "모든 프로세스 덮어쓰기",
  is_override_all_sequences_desc:
    "동일한 식별자의 다른 프로세스가 있는 경우 이 새 프로세스로 업데이트합니다.",
  sequence_targets_import_csv_map_crm_column: "필드",
  sequence_targets_import_csv_map_file_column: "파일 필드",
  sequence_targets_import_csv_upload_success: "업로드 완료",
  sequence_targets_import_csv_upload_summary: "결과 요약",
  sequence_targets_import_csv_upload_summary_upload_success: "성공한 업로드:",
  sequence_targets_import_csv_upload_summary_targets:
    "0개 타겟 | 1개 타겟 | {count}개 타겟",
  sequence_targets_import_csv_upload_summary_upload_skip:
    "건너뜀 (할당됨 또는 중복):",
  sequence_targets_create_manual_drawer_title: "타겟 생성",
  locations_company_locations: "계정 본사",
  locations_people_locations: "연락처 본사",
  sequence_targets_add_import_from_csv_button_name: "CSV에서 가져오기",
  sequence_targets_add_create_manual_button_name: "수동 생성",
  sequence_detail_target_add_targets: "연락처 추가",
  sequence_targets_filter_steps_version: "버전",
  sequence_targets_filter_steps_action: "작업",

  sequence_targets_filter_sequence_status: "프로세스 상태",
  sequence_targets_filter_steps: "단계",
  sequence_targets_filter_name: "이름",
  sequence_targets_filter_job_title: "직함",
  sequence_targets_filter_management_level: "관리 수준",
  sequence_targets_filter_department: "부서",
  sequence_targets_filter_job_function: "직무",
  sequence_targets_filter_company: "회사",
  sequence_targets_filter_location: "위치",
  sequence_targets_filter_employees: "직원 수",

  steps_sequence_steps: "버전",
  steps_sequence_step_actions: "노드",

  sequence_target_bar_finish_tooltip: "워크플로우를 완료로 표시",
  sequence_target_bar_pause_tooltip: "워크플로우 일시 정지",
  sequence_target_bar_play_tooltip: "워크플로우 재개",
  sequence_target_bar_remove_tooltip: "워크플로우에서 제거",
  sequence_target_bar_export_tooltip: "내보내기",

  not_a_portal_record: "포털 기록이 아닙니다",

  sequence_targets_identifier_explaination:
    "중복을 정확히 감지하고 관리하기 위해 식별자를 설정합니다",

  sequence_targets_import_replace: "중복 항목 교체",
  sequence_targets_import_replace_desc:
    "연락처가 이미 존재하는 경우 CSV 버전으로 덮어씁니다.",

  sequence_targets_import_merge: "중복 항목 건너뛰기",
  sequence_targets_import_merge_desc:
    "기존 연락처를 유지하고 새 연락처만 추가합니다.",

  sequence_targets_import_skip: "중복 항목 병합",
  sequence_targets_import_skip_desc:
    "연락처가 존재하는 경우 두 레코드를 결합합니다. 새 연락처도 추가합니다.",

  sequence_targets_import_csv_batch_create_fields_title:
    "새 속성에 필드 유형 할당",
  create_fields: "필드 생성",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_label:
    "필드 이름",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_placeholder:
    "필드 이름을 입력하세요",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_label:
    "필드 유형",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_placeholder:
    "필드 유형을 선택하세요",
  set_for_all: "모두 설정",
  sequence_targets_import_update: "업데이트만",
  sequence_targets_import_update_desc:
    "기존 연락처만 업데이트합니다. 새 연락처는 추가하지 않습니다.",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_label:
    "중복 항목 처리",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_title:
    "변경 사항 덮어쓰기",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_desc:
    "대상이 이미 시퀀스에 존재하는 경우 덮어씁니다.",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_title:
    "중복 항목 교체",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_desc:
    "대상이 현재 시퀀스에 이미 존재하는 경우 덮어씁니다.",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_title:
    "중복 항목 병합",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_desc:
    "대상이 이미 존재하는 경우 두 레코드를 결합합니다.",
  text_separator: "텍스트 그룹 구분자",
  text_separator_placeholder: "텍스트 그룹 구분자를 입력하세요",
  auto_create_column: "자동 열 생성",
  new_column_type: "새 열 유형",
  new_column_type_placeholder: "필드 유형 할당",
  sequence_targets_import_csv_map_fields_submit_button: "연락처 가져오기",
};

export const sequence_detail_targets_hindi = {
  sequence_targets_column_account_at: "पर",
  sequence_detail_targets: "लक्ष्य",
  sequence_detail_targets_count: "0 लक्ष्य | 1 लक्ष्य | {count} लक्ष्य",
  sequence_targets_column_account: "खाता",
  sequence_targets_column_step_name: "प्रक्रिया चरण",
  sequence_targets_column_status: "प्रक्रिया स्थिति",
  sequence_targets_column_save_contact_to: "संपर्क को सहेजें",
  sequence_targets_column_contact: "संपर्क",
  remove_sequences_from_target_successfully: "हटाना सफल",
  remove_sequences_from_target_failed: "हटाना विफल",
  add_targets_to_sequence_successfully: "जोड़ना सफल",
  add_targets_to_sequence_failed: "जोड़ना विफल",
  sequence_targets_sequence_unsave_count:
    "0 लक्ष्य | 1 लक्ष्य | {count} लक्ष्य",
  sequence_create_sequence: "प्रक्रिया बनाएं",
  sequence_action_sequence_empty:
    "स्वचालित संपर्क शुरू करने के लिए एक प्रक्रिया बनाएं और तैयार होने पर आइटम यहां जोड़ें।",
  sequence_targets_import_csv_loading_title: "डेटा विश्लेषण हो रहा है⋯",
  sequence_targets_import_csv_loading_desc:
    "ईमेल, नाम, कंपनी आदि फ़ील्ड खोज रहे हैं⋯",
  drag_and_drop: "ड्रैग और ड्रॉप या",
  sample_csv: "contact_sequence_samplefile.csv",
  sequence_targets_import_upload_csv: "CSV अपलोड करें",
  sequence_targets_import_map_attributes: "फ़ील्ड मैपिंग",
  is_override_existing_sequence: "मौजूदा प्रक्रिया को ओवरराइड करें",
  is_override_existing_sequence_desc:
    "यदि समान पहचानकर्ता वाली प्रक्रिया पहले से मौजूद है, तो छोड़ें और अपडेट न करें।",
  is_override_all_sequences: "सभी प्रक्रियाओं को ओवरराइड करें",
  is_override_all_sequences_desc:
    "यदि समान पहचानकर्ता वाली अन्य प्रक्रियाएं हैं, तो इस नई प्रक्रिया के साथ अपडेट करें।",
  sequence_targets_import_csv_map_crm_column: "फ़ील्ड",
  sequence_targets_import_csv_map_file_column: "फ़ाइल फ़ील्ड",
  sequence_targets_import_csv_upload_success: "अपलोड पूर्ण",
  sequence_targets_import_csv_upload_summary: "परिणाम सारांश",
  sequence_targets_import_csv_upload_summary_upload_success: "सफल अपलोड:",
  sequence_targets_import_csv_upload_summary_targets:
    "0 लक्ष्य | 1 लक्ष्य | {count} लक्ष्य",
  sequence_targets_import_csv_upload_summary_upload_skip:
    "छोड़ दिया गया (आवंटित या डुप्लिकेट):",
  sequence_targets_create_manual_drawer_title: "लक्ष्य बनाएं",
  locations_company_locations: "खाता मुख्यालय",
  locations_people_locations: "संपर्क मुख्यालय",
  sequence_targets_add_import_from_csv_button_name: "CSV से आयात करें",
  sequence_targets_add_create_manual_button_name: "मैन्युअल बनाएं",
  sequence_detail_target_add_targets: "संपर्क जोड़ें",
  sequence_targets_filter_steps_version: "संस्करण",
  sequence_targets_filter_steps_action: "क्रिया",

  sequence_targets_filter_sequence_status: "प्रक्रिया स्थिति",
  sequence_targets_filter_steps: "चरण",
  sequence_targets_filter_name: "नाम",
  sequence_targets_filter_job_title: "पदनाम",
  sequence_targets_filter_management_level: "प्रबंधन स्तर",
  sequence_targets_filter_department: "विभाग",
  sequence_targets_filter_job_function: "कार्य",
  sequence_targets_filter_company: "कंपनी",
  sequence_targets_filter_location: "स्थान",
  sequence_targets_filter_employees: "कर्मचारी संख्या",

  steps_sequence_steps: "संस्करण",
  steps_sequence_step_actions: "नोड",

  sequence_target_bar_finish_tooltip:
    "वर्कफ़्लो को पूर्ण के रूप में चिह्नित करें",
  sequence_target_bar_pause_tooltip: "वर्कफ़्लो को विराम दें",
  sequence_target_bar_play_tooltip: "वर्कफ़्लो फिर से शुरू करें",
  sequence_target_bar_remove_tooltip: "वर्कफ़्लो से हटाएं",
  sequence_target_bar_export_tooltip: "निर्यात करें",

  not_a_portal_record: "अभी तक पोर्टल रिकॉर्ड नहीं है",

  sequence_targets_identifier_explaination:
    "डुप्लिकेट का सटीक पता लगाने और प्रबंधन के लिए पहचानकर्ता सेट करें",

  sequence_targets_import_replace: "डुप्लिकेट प्रतिस्थापित करें",
  sequence_targets_import_replace_desc:
    "यदि कोई संपर्क पहले से मौजूद है, तो उसे CSV संस्करण से ओवरराइट करें।",

  sequence_targets_import_merge: "डुप्लिकेट छोड़ें",
  sequence_targets_import_merge_desc:
    "मौजूदा संपर्कों को रखें, केवल नए जोड़ें।",

  sequence_targets_import_skip: "डुप्लिकेट मर्ज करें",
  sequence_targets_import_skip_desc:
    "यदि कोई संपर्क मौजूद है, तो दोनों रिकॉर्ड संयोजित करें। नए भी जोड़ें।",

  sequence_targets_import_csv_batch_create_fields_title:
    "नए एट्रिब्यूट्स के लिए फ़ील्ड प्रकार असाइन करें",
  create_fields: "फ़ील्ड बनाएं",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_label:
    "फ़ील्ड नाम",
  sequence_targets_import_csv_batch_create_fields_table_csv_header_placeholder:
    "कृपया फ़ील्ड नाम दर्ज करें",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_label:
    "फ़ील्ड प्रकार",
  sequence_targets_import_csv_batch_create_fields_table_detected_crm_schema_column_placeholder:
    "कृपया फ़ील्ड प्रकार चुनें",
  set_for_all: "सभी के लिए सेट करें",
  sequence_targets_import_update: "केवल अपडेट करें",
  sequence_targets_import_update_desc:
    "केवल मौजूदा संपर्कों को अपडेट करें। नए न जोड़ें।",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_label:
    "डुप्लिकेट हैंडलिंग",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_title:
    "परिवर्तन ओवरराइड करें",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_override_desc:
    "यदि लक्ष्य पहले से किसी अनुक्रम में मौजूद है, तो उसे ओवरराइट कर दिया जाएगा।",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_title:
    "डुप्लिकेट प्रतिस्थापित करें",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_replace_desc:
    "यदि लक्ष्य वर्तमान अनुक्रम में पहले से मौजूद है, तो उसे ओवरराइट कर दिया जाएगा।",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_title:
    "डुप्लिकेट मर्ज करें",
  sequence_targets_import_csv_fields_map_settings_duplicate_handling_is_merge_desc:
    "यदि लक्ष्य पहले से मौजूद है, तो दोनों रिकॉर्ड संयोजित करें।",
  text_separator: "टेक्स्ट ग्रुप सेपरेटर",
  text_separator_placeholder: "कृपया टेक्स्ट ग्रुप सेपरेटर दर्ज करें",
  auto_create_column: "ऑटो क्रिएट कॉलम",
  new_column_type: "नया कॉलम प्रकार",
  new_column_type_placeholder: "फ़ील्ड प्रकार असाइन करें",

  sequence_targets_import_csv_map_fields_submit_button: "संपर्क आयात करें",
};
